import React, { useEffect, useState } from "react";
import { AbsoluteFill, continueRender, delayRender, staticFile, useCurrentFrame } from "remotion";
import { ThreeCanvas } from "@remotion/three";
import * as THREE from "three";
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader.js";

const ZuraRealGLBMesh: React.FC<{ frame: number }> = ({ frame }) => {
  const [handle] = useState(() => delayRender("Loading GLB"));
  const [scene, setScene] = useState<THREE.Group | null>(null);

  useEffect(() => {
    const loader = new GLTFLoader();
    loader.load(
      staticFile("zura_chibi_avatar_v2.glb"),
      (gltf) => {
        console.log("GLB loaded successfully!");
        // Compute bounding box to center it
        const box = new THREE.Box3().setFromObject(gltf.scene);
        const center = box.getCenter(new THREE.Vector3());
        const size = box.getSize(new THREE.Vector3());
        console.log("GLB Center:", center, "Size:", size);
        gltf.scene.position.x = -center.x;
        gltf.scene.position.y = -center.y;
        gltf.scene.position.z = -center.z;
        setScene(gltf.scene);
        continueRender(handle);
      },
      undefined,
      (err) => {
        console.error("GLB load error:", err);
        continueRender(handle);
      }
    );
  }, [handle]);

  if (!scene) return null;

  return (
    <primitive
      object={scene}
      position={[0, 0, 0]}
      scale={[1.8, 1.8, 1.8]}
      rotation={[0, Math.sin(frame * 0.05) * 0.3, 0]}
    />
  );
};

export const TestZuraGLBComposition: React.FC = () => {
  const frame = useCurrentFrame();
  return (
    <AbsoluteFill style={{ backgroundColor: "#222" }}>
      <ThreeCanvas width={1080} height={1920} camera={{ position: [0, 0, 2.5], fov: 40 }}>
        <ambientLight intensity={2.0} />
        <directionalLight position={[2, 4, 3]} intensity={3.0} />
        <directionalLight position={[-2, 2, -2]} intensity={1.5} />
        <ZuraRealGLBMesh frame={frame} />
      </ThreeCanvas>
    </AbsoluteFill>
  );
};
